import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

//FUNCTIONS
import { customApp } from "functions/";

// Inspired by the former Facebook spinners.
const useStylesFacebook = makeStyles((theme) => ({
    root: {
        position: 'relative',
    },
    bottom: {
        color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        position: 'absolute',
        left: 0,
    },
    top: {
        color: customApp('ColumnTitleColor'),
        animationDuration: '550ms',
        position: 'absolute',
        left: 0,
    },
    circle: {
        strokeLinecap: 'round',
    },
}));

function FacebookCircularProgress(props) {
    const classes = useStylesFacebook();

    return (
        <div className={classes.root}
            style={{
                width: props.size ? props.size : '25px',
                height: props.size ? props.size : '25px',
            }}>
            <CircularProgress
                variant="determinate"
                className={classes.bottom}
                size={props.size ? props.size : 25}
                thickness={4}
                {...props}
                value={100}
            />
            <CircularProgress
                variant="indeterminate"
                disableShrink
                className={classes.top}
                classes={{
                    circle: classes.circle,
                }}
                size={props.size ? props.size : 25}
                thickness={4}
                {...props}
            />
        </div>
    );
}

export default FacebookCircularProgress